export const ContentTypes = {
  JSON: "application/json",
};

export const ResponseHeaders = {
  ContentType: "Content-Type",
};
